import React from 'react';
import { motion } from 'motion/react';

export const EnhancedLoader = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50 dark:bg-slate-950">
      <motion.div 
        className="relative w-24 h-24"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
      >
        <motion.div 
          className="absolute inset-0 border-4 border-t-blue-500 border-r-transparent border-b-emerald-500 border-l-transparent rounded-full"
          animate={{ rotate: 360 }}
          transition={{ duration: 1.5, repeat: Infinity, ease: "linear" }}
        />
        <motion.div 
          className="absolute inset-2 border-4 border-t-transparent border-r-indigo-500 border-b-transparent border-l-cyan-500 rounded-full"
          animate={{ rotate: -360 }}
          transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
        />
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-4 h-4 bg-blue-500 rounded-full" />
        </div>
      </motion.div>
      <motion.p 
        className="mt-8 text-slate-600 dark:text-slate-400 font-medium tracking-widest uppercase text-sm"
        animate={{ opacity: [0.5, 1, 0.5] }}
        transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
      >
        Processando Dados
      </motion.p>
    </div>
  );
};
